<ng-template #bulkOrderModalFormContent role="document" let-modal>

  <app-page-comp-header [title]="formTitle"></app-page-comp-header>

  <form (ngSubmit)="bulkOrderFormSubmitAttempt()" [formGroup]="bulkOrderForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <!-- <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
              <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
              <span [innerHtml]="progressInformation"></span>
            </div>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="firstname-field" class="form-label">Firstname</label>
            <input autocomplete="no-fill" type="text" id="firstname-field" class="form-control" placeholder="" formControlName="firstname" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['firstname'].errors }" />
            @if(formOfBulkOrderAdd['firstname'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{firstnameMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>  
        <div class="col-6">
          <div class="mb-3">
            <label for="lastname-field" class="form-label">Lastname</label>
            <input autocomplete="no-fill" type="text" id="lastname-field" class="form-control" placeholder="" formControlName="lastname" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['lastname'].errors }" />
            @if(formOfBulkOrderAdd['lastname'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{lastnameMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="tag-field" class="form-label">User Ref 1</label>
            <input autocomplete="no-fill" type="text" id="tag-field" class="form-control" placeholder="" formControlName="tag" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['tag'].errors }" />
            @if(formOfBulkOrderAdd['tag'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{tagMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="tag2-field" class="form-label">User Ref 2</label>
            <input autocomplete="no-fill" type="text" id="tag2-field" class="form-control" placeholder="" formControlName="tag2" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['tag2'].errors }" />
            @if(formOfBulkOrderAdd['tag2'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{tag2MaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6" [hidden]="useInternationalDialCode">
          <div class="mb-3">
            <label for="mobilenumber-field" class="form-label">Mobile</label>
            <input autocomplete="no-fill" type="text" id="mobilenumber-field" class="form-control text-end" placeholder="" formControlName="mobilenumber" data-lpignore="true" (input)="mobileConflict = false" [ngClass]="{ 'is-invalid': (formSubmitted && formOfBulkOrderAdd['mobilenumber'].errors) || mobileConflict }" />
            @if (mobileConflict) {
              <!--RBW_20260805 - The mobilenumber control is disabled on this form (the dropdown owns the input), so form validation
                                 can't flag the conflict; drive the message from the mobileConflict flag set in mobileNumberOK instead.-->
              <div class="invalid-feedback d-block">{{ mobileConflictMessage }}</div>
            } @else if (formOfBulkOrderAdd['mobilenumber'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{mobilenumberMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
        @if (useInternationalDialCode) {
          <div class="col-6">
            <div class="mb-3">
              <app-dropdown-country-dialling-code
                #dialCodeDropdown
                [mobileNumber]="formOfBulkOrderAdd['mobilenumber'].value"
                [mobileNumberIntCode]="formOfBulkOrderAdd['mobilenumberIntCode'].value"
                (valueChanged)="mobileConflict = false"
              >
              </app-dropdown-country-dialling-code>
              @if (mobileConflict) {
                <!--RBW_20260805 - Same reason as the plain input: show the conflict from the flag, not from the disabled control.-->
                <div class="invalid-feedback d-block">{{ mobileConflictMessage }}</div>
              }
            </div>
          </div>
        }
        <div class="col-6">
          <div class="mb-3">
            <label for="email-field" class="form-label">Email</label>
            <input
              autocomplete="no-fill"
              type="text"
              id="email-field"
              class="form-control"
              placeholder=""
              formControlName="email"
              data-lpignore="true"
              (keyup)="emailkeyup($event)"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['email'].errors }" />

              @if(formOfBulkOrderAdd['email'].hasError('maxlength')) {
                <div class="invalid-feedback">Maximum length of {{emailMaxLength}} characters has been exceeded</div>
              } @else if(formOfBulkOrderAdd['email'].hasError('invalidEmail')) {
                <div class="invalid-feedback">Value is not a valid e-mail address</div>
              } @else {
                <div class="invalid-feedback">A value is required</div>
              }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="simType-field" class="form-label">Sim Type</label>
            <select id="simType-field" class="form-select" formControlName="simType" (change)="provisioningFieldChange()" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['simType'].errors }">
              @for (option of simTypeOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
            <div class="invalid-feedback">Sim Type is required</div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="isIOTDevice-field" class="form-label">Use Type</label>
            <select id="isIOTDevice-field" class="form-select" formControlName="isIOTDevice" (change)="iotDeviceChange()">
              @for (option of useTypeOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="provisionType-field" class="form-label">Deploy Method</label>
            <select id="provisionType-field" class="form-select" formControlName="provisionType" (change)="provisioningFieldChange()" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['provisionType'].errors }">
              @for (option of provisionTypeOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
            @if(formOfBulkOrderAdd['provisionType'].hasError('iccidOnly')) {
              <div class="invalid-feedback">A physical SIM can only be deployed via ICCID</div>
            } @else if(formOfBulkOrderAdd['provisionType'].hasError('iotDeploy')) {
              <div class="invalid-feedback">An IOT device can only be provisioned via EID or Manual</div>
            } @else {
              <div class="invalid-feedback">Deploy Method is required</div>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="deviceOS-field" class="form-label">Device OS</label>
            <select id="deviceOS-field" class="form-select" formControlName="deviceOS" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['deviceOS'].errors }">
              <option [ngValue]="''"></option>
              @for (option of deviceOSOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
            <div class="invalid-feedback">Device OS is required when sending via SMS/Email</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="iccid-field" class="form-label">ICCID</label>
            <input autocomplete="no-fill" type="text" id="iccid-field" class="form-control" placeholder="" formControlName="iccid" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['iccid'].errors }" />
            @if(formOfBulkOrderAdd['iccid'].hasError('mustBeEmpty')) {
              <div class="invalid-feedback">You can only specify an ICCID for Physical SIMs</div>
            } @else {
              <div class="invalid-feedback">ICCID is required for a physical SIM</div>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="eid-field" class="form-label">Eid</label>
            <input autocomplete="no-fill" type="text" id="eid-field" class="form-control" placeholder="" formControlName="eid" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['eid'].errors }" />
            @if(formOfBulkOrderAdd["eid"].hasError("minlength") || formData["eid"].hasError("maxlength")) {
              <div class="invalid-feedback">EID must be 32 digits in length</div>
            } @else if(formOfBulkOrderAdd["eid"].hasError("pattern")) {
              <div class="invalid-feedback">EID must contain number characters only</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      @if (showCostCentres) {
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="inviewCostCentreIdLv2-field" class="form-label text-right">Cost Centre Level 2</label>
            <input list="costCentre2Options" id="inviewCostCentreIdLv2-field" class="form-control" (focus)="clearDataList('inviewCostCentreIdLv2')" (change)="onSelect($event, 'inviewCostCentreIdLv2')" placeholder="" formControlName="inviewCostCentreIdLv2" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['inviewCostCentreIdLv2'].errors }" />
            <datalist id="costCentre2Options">
            @for (object of getDropdownDataObjectArray("inviewCostCentreIdLv2"); track object.description)
              {
                <option [value]="object.description">{{object.description}}</option>
              }
            </datalist>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="inviewCostCentreIdLv1-field" class="form-label text-right">Cost Centre Level 1</label>
            <input list="costCentre1Options" id="inviewCostCentreIdLv1-field" class="form-control" (focus)="clearDataList('inviewCostCentreIdLv1')" (change)="onSelect($event, 'inviewCostCentreIdLv1')" placeholder="" formControlName="inviewCostCentreIdLv1" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['inviewCostCentreIdLv1'].errors }" />
            <datalist id="costCentre1Options">
            @for (object of getDropdownDataObjectArray("inviewCostCentreIdLv1"); track object.description)
              {
                <option [value]="object.description">{{object.description}}</option>
              }
            </datalist>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
      }

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="simRef-field" class="form-label">SIM Ref</label>
            <input autocomplete="no-fill" type="text" id="simRef-field" class="form-control" placeholder="" formControlName="simRef" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['simRef'].errors }" />
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="product-field" class="form-label text-right">Product</label>
            <input list="productOptions" id="product-field" class="form-control" (focus)="clearDataList('product')" (change)="onSelect($event, 'product')" placeholder="" formControlName="product" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['product'].errors }" />
            <datalist id="productOptions">
            @for (object of getDropdownDataObjectArray("product"); track object.description)
              {
                <option [value]="object.description">{{object.description}}</option>
              }
            </datalist>
            @if(formData["product"].hasError("invalidProductSelection")) {
              <div class="invalid-feedback">Invalid product</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="inheritCompanyLimit-field" class="form-label">Inherit Company Limit</label>
            <select id="inheritCompanyLimit-field" class="form-select" formControlName="inheritCompanyLimit" (change)="provisioningFieldChange()">
              @for (option of yesNoOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3" [hidden]="formOfBulkOrderAdd['inheritCompanyLimit'].value === true">
            <label for="limitType-field" class="form-label">Limit Type</label>
            <select id="limitType-field" class="form-select" formControlName="limitType" (change)="provisioningFieldChange()" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['limitType'].errors }">
              <option [ngValue]="''"></option>
              @for (option of limitTypeOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
            <div class="invalid-feedback">Limit Type is required</div>
          </div>
        </div>
      </div>

      <div class="row" [hidden]="formOfBulkOrderAdd['inheritCompanyLimit'].value === true">
        <div class="col-6">
          <div class="mb-3" [hidden]="!(formOfBulkOrderAdd['limitType'].value === 2 || formOfBulkOrderAdd['limitType'].value === 3)">
            <label for="limitAmount-field" class="form-label">Limit Amount</label>
            <input autocomplete="no-fill" type="number" id="limitAmount-field" class="form-control" placeholder="" formControlName="limitAmount" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['limitAmount'].errors }" />
            <div class="invalid-feedback">Limit Amount is required</div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3" [hidden]="formOfBulkOrderAdd['limitType'].value !== 3">
            <label for="dataWeightCode-field" class="form-label">Limit Data Weight</label>
            <select id="dataWeightCode-field" class="form-select" formControlName="dataWeightCode" [ngClass]="{ 'is-invalid': formSubmitted && formOfBulkOrderAdd['dataWeightCode'].errors }">
              <option [ngValue]="''"></option>
              @for (option of dataWeightOptions; track option.id) {
                <option [ngValue]="option.id">{{ option.description }}</option>
              }
            </select>
            <div class="invalid-feedback">Limit Data Weight is required</div>
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="bulkOrderFormCancel()">Close</button>
        <button type="submit" [disabled]="!submitButtonEnabled" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="bulkOrderCompletedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
